'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_monitoring.demand_detail', {
    template: '<demand-detail></demand-detail>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/demand/detail/demand_detail.routes.js